import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { Card } from '@/components/Atoms/AuthV2/Card';
import { Container } from '@/components/Atoms/AuthV2/Container';
import { Heading } from '@/components/Auth/typography';
import { loginUserAzure } from '@/components/AuthProvider/azure';
import { Footer } from '@/components/AuthV2/Footer';
import { FooterWrapper } from '@/components/AuthV2/wrappers';
import { Button } from '@/components/Button/Button';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';
import MicrosoftIcon from '@/logos/Microsoft_logo.svg?react';

const AzureAuth = (): JSX.Element => {
  const { path } = useRouteMatch();
  const { desktopAndBelow } = useResponsiveConstants();

  return (
    <Switch>
      <Route path={`${path}/signin`}>
        <Container>
          <Card className='lg:items-start'>
            <Heading className='hidden lg:block' center={false}>
              Welcome
            </Heading>
            <Button
              onClick={async () => {
                window.localStorage.setItem('oauth-signin', 'Microsoft');
                await loginUserAzure();
              }}
              startIcon={<MicrosoftIcon />}
              variant='oauth'
              fullWidth={desktopAndBelow}
              className='text-gray-700'
            >
              Continue with Microsoft
            </Button>
          </Card>
          <FooterWrapper>
            <Footer fromSignUp={false} />
          </FooterWrapper>
        </Container>
      </Route>
      <Route path='*'>
        <Redirect to={`${path}/signin`} />
      </Route>
    </Switch>
  );
};

export default AzureAuth;
